import { resolveMapOverlayGapAboveAnchorPx } from "./lib/map-overlay-gap";

export interface MapStopPreviewSpeechBubbleModel {
	stopId: string;
	stopType: "TOPIC" | "BATTLE" | "SCENARIO" | "BOSS";
	stopIconSrc: string;
	encounterPortraitSrc: string | null;
}

/** Map preview bubble face size — 2× the default map speech bubble (58px). */
export const HEXAGON_MAP_PREVIEW_SPEECH_BUBBLE_SIZE_PX = 116;

/**
 * Content-space focal point for the tile + preview bubble cluster.
 * Bubble height in content px is `sizePx / contentMapScale` (see speech layer inverse scale).
 */
export function resolveMapStopPreviewSpotlightContentPoint({
	cellCenterX,
	cellCenterY,
	hexagonHeight,
	userZoom,
	contentMapScale,
}: {
	cellCenterX: number;
	cellCenterY: number;
	hexagonHeight: number;
	userZoom: number;
	contentMapScale: number;
}): { x: number; y: number } {
	const tileTop = cellCenterY - hexagonHeight / 2;
	const tileBottom = cellCenterY + hexagonHeight / 2;
	const gapAboveTilePx = resolveMapOverlayGapAboveAnchorPx(userZoom);
	const bubbleHeightContentPx =
		contentMapScale > 0
			? HEXAGON_MAP_PREVIEW_SPEECH_BUBBLE_SIZE_PX / contentMapScale
			: HEXAGON_MAP_PREVIEW_SPEECH_BUBBLE_SIZE_PX;
	const bubbleBottom = tileTop - gapAboveTilePx;
	const bubbleTop = bubbleBottom - bubbleHeightContentPx;
	return {
		x: cellCenterX,
		y: (bubbleTop + tileBottom) / 2,
	};
}
